<template lang="pug">
  .app-header-mobile.relative

    //- header
    .relative.z-10.flex.h-72.w-full.items-center.justify-between.px-12(:class="[theme === 'dark' && !menu ? 'text-white' : 'text-black', {'bg-white': y > 0 && canCollapse && !collapsed}]", style="transition: color 200ms, background 100ms")
      //- title (A5: unchanged)
      .px-12.text-21.tracking-40.pt-2.font-medium
        a(href="/", @click.prevent="$emit('refresh')") Guido van Helten
      //- right btns
      .flex(style="transition: opacity 100ms", :class="{'opacity-0': collapsed}")
        //- bag btn
        router-link.block.p-12.content-box(:to="{name: 'cart'}")
          svg-bag.block(style="height:2.3rem")
        //- menu btn
        button.p-12.content-box.flex.items-center.justify-center.w-25.h-29(aria-label="Menu", @click="menu = !menu", :class="{'opacity-0': hideNav, 'pointer-events-none': collapsed}", :disabled="hideNav || collapsed")
          span.block.w-25.h-16.border-t-2.border-b-2.border-current(v-show="!menu")
          svg-x.w-20.h-20(v-show="menu")

    //- (menu overlay)
    transition(name="quickfade")
      nav.absolute.top-0.left-0.h-screen.w-full.bg-white.pt-72.overflow-y-scroll(v-show="menu")
        ul.list-reset.leading-loose.px-24.pb-24.type-menu
          li
            router-link(:to="{name: 'home'}", @click.native="menu = false") Selected Works
          li
            router-link.app-header-mobile__parent-rt(:to="{name: 'projects'}", @click.native="menu = false") Projects
            ul.list-reset.ml-tab
              li
                router-link(:to="{name: 'projects', query: {view: 'gallery'}}", :class="{'font-medium': $route.name === 'projects' && (!$route.query.view || $route.query.view === 'image')}", @click.native="menu = false") Gallery
              li
                router-link(:to="{name: 'projects', query: {view: 'map'}}", :class="{'font-medium': $route.query.view === 'map'}", @click.native="menu = false") Map
              li
                router-link(:to="{name: 'projects', query: {view: 'archive'}}", :class="{'font-medium': $route.query.view === 'text'}", @click.native="menu = false") Archive
          li
            router-link(:to="{name: 'page', params: {uid: 'info'}}", @click.native="menu = false") About
            ul.list-reset.ml-tab
              li(v-for="(itm, i) in infoNav")
                router-link(:to="{name: 'page', params: {uid: 'info'}, hash: '#' + idy(itm) }", @click.native="menu = false") {{itm}}
          li
            router-link(:to="{name: 'page', params: {uid: 'press'}}", @click.native="menu = false") Press
          li
            router-link(:to="{name: 'editions'}", @click.native="menu = false") Shop

</template>

<script>
import { mapState } from 'vuex'
import { idy, getNav, dedupeNavLabelScrollPoint } from '@/utils'
import svgX from '@/components/Icons/SVG-X'
import svgBag from '@/components/Icons/SvgBag'
export default {
  name: 'AppHeader--Mobile',
  props: ['hideNav', 'collapsed', 'y', 'canCollapse'],
  data () {
    return {
      menu: false,
      infoNav: [],
      idy
    }
  },
  computed: {
    ...mapState(['theme'])
  },
  watch: {
    '$route' () {
      this.menu = false
    }
  },
  created () {
    this.$store.dispatch('getPage', 'info').then(doc => {
      // 'About' is this route's own hardcoded main-nav label (see the nav list above) — the info
      // page's own "About" scroll_point is dropped so the word doesn't appear twice, back to back
      if (doc && doc.data) this.infoNav = getNav(dedupeNavLabelScrollPoint(doc.data.body, 'About'))
    })
  },
  components: { svgX, svgBag }
}
</script>

<style>
.app-header-mobile .router-link-exact-active,
.app-header-mobile .app-header-mobile__parent-rt.router-link-active {
  font-weight: 500
}
</style>
